import { combineReducers } from 'redux'
import passList from './pass-list'
import uiControl from './ui-control'
import guest from './guest'
import scan from './scan'
import settings from './settings'
export default combineReducers({
  passList,
  guest,
  uiControl,
  scan,
  settings
});


// WEBPACK FOOTER //
// ./src/reducers/index.js